// import { AdministrativeCheckPage } from '@/features/city-clerk/admin-check'
import NewAdministrativeCheckPage from '@/features/city-clerk/admin-check/pages/NewAdministrativeCheckPage/NewAdministrativeCheckPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permit-checklist-setup/$permitId/$permitSubmitalId/administrative-check/',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.administrativeCheckView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})
function RouteComponent() {
  return <NewAdministrativeCheckPage />
  // return <AdministrativeCheckPage />
}
